import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { IFormWizardConfig } from '../../../interfaces/form-wizard-config';
import { IConfirmModalConfig } from '../../../interfaces/modal-dialog-config.interface';
import { ModalDialogService } from '../../../services/modalDialog/modal-dialog.service';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss'],
})
export class WizardComponent implements OnInit {
  @Input() wizardConfig: IFormWizardConfig;
  @Input() boType: number | undefined;

  @Output() emitWizardFields = new EventEmitter<any>();

  @ViewChild('wizard', {
    static: false,
  })
  wizard: any;

  curPage = 0;
  maxPage: number;
  changes: any = {};
  continueDisabledAfter = 0;

  constructor(private modalService: ModalDialogService) {}

  /**
   * handleChange() stores the emitted changes object
   * @param item
   * @returns void
   */
  handleChange(item: any): void {
    this.changes = item;
  }

  /**
   * pageUp() will increment the current page by 1 up until the maximum page
   * If it is on the final page, paging up will submit changes and return user to All Fields with updated data
   * @returns void
   */
  pageUp(): void {
    if (this.curPage < this.maxPage) this.curPage += 1;
    else if (this.curPage >= this.maxPage) {
      this.wizard?.emitChange();
      this.submitWizard();
    }
  }

  /**
   * pageDown() will decrement the current page by 1 until the first page
   * @returns void
   */
  pageDown(): void {
    if (this.curPage > 0) this.curPage -= 1;
  }

  /**
   * startOver() will ask first for confirmation from the user to discard changes
   * If yes, will remove all changes and return user to first page
   * @returns void
   */
  startOver(fromEditDocument: boolean = false): void {
    if (fromEditDocument) {
      this.curPage = 0;
      this.wizard?.startOver();
    } else {
      const confirmConfig: IConfirmModalConfig = {
        title: 'Confirm reset',
        message: 'Are you sure you would like to start over? You will lose your progress.',
        confirmBtnLabel: 'Confirm',
        confirmBtnCssClass: 'btn btn-danger px-sm-4',
        cancelBtnLabel: 'Cancel',
      };
      this.modalService.showConfirmModal(confirmConfig)?.subscribe(confirm => {
        if (confirm) {
          this.curPage = 0;
          this.wizard.startOver();
        }
      });
    }
  }

  /**
   * pageClick() will direct the user to the clicked on page if not disabled
   * @param page
   * @returns void
   */
  pageClick(page: any): void {
    if (this.continueDisabledAfter >= page.page) this.curPage = page.page;
  }

  /**
   * isContinueDisabled sets the page after which progress is disabled
   * for validation purposes
   * @param e
   * @returns void
   */
  isContinueDisabled(e: any) {
    this.continueDisabledAfter = e;
  }

  /**
   * isStartOverDisabled() determines if startOver is enabled
   * based upon if it is past page 1 or if the user has made any changes
   * @returns boolean
   */
  isStartOverDisabled(): boolean {
    const keys: any[] = Object.keys(this.changes);
    if (this.curPage > 0 || keys.length > 0) return false;
    return true;
  }

  /**
   * submitWizard() emits the final wizard changes to edit-document.component
   * @returns void
   */
  submitWizard() {
    this.emitWizardFields.emit(this.changes);
  }

  ngOnInit(): void {
    // calculating the maximum page number by the number of pages passed in by the config object
    this.maxPage = this.wizardConfig?.pages.length - 1;
  }
}
